import { OrgRole } from '@/features/org/validation/org-role.schema';

export function getOrgRoleDisplay(
  role: OrgRole,
  t: (key: string) => string,
): string {
  const displayMap: Record<OrgRole, string> = {
    [OrgRole.OWNER]: t('owner'),
    [OrgRole.ADMIN]: t('admin'),
    [OrgRole.MEMBER]: t('member'),
  };

  return displayMap[role];
}
